import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks';
import { USER_ROLES } from '@/constants/app';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  const getNavigationPath = (): string => {
    if (!user) return '/bookings';
    
    switch (user.role) {
      case USER_ROLES.Booking_Viewer:
      case USER_ROLES.Booking_SuperAdmin:
      case USER_ROLES.Booking_Admin:

        return '/bookings';
      // case USER_ROLES.STUDENT:
      // case USER_ROLES.PARENT:
        // return '/profile';
      default:
        return '/bookings';
    }
  };

  if (isAuthenticated && user) {
    const navigationPath = getNavigationPath();
    return <Navigate to={navigationPath} replace />;
  }

  return <>{children}</>;
};